import * as Sentry from '@sentry/react';
import createRawDebug from 'debug';

import { DebugKey } from './DebugKey';

/**
 * Any namespaces defined in this list will automatically write a breadcrumb to Sentry to aid issue debugging.
 */
const sentryLoggingNamespaces = [DebugKey.C2L, DebugKey.Embedded, DebugKey.Socket];

/**
 * Extends "debug" by appending the request id to logs and adds Sentry breadcrumb support
 * @param namespace - an enum of debug namespaces
 * @param requestId - the request id
 * @returns a function for logging debug information
 */
export const createDebug = (namespace: DebugKey, requestId?: string) => {
  const debug = createRawDebug(namespace);

  return (message: string, ...args: unknown[]) => {
    const formattedMessage = requestId ? `requestId: %s | ${message}` : message;
    const argsWithRequestId = requestId ? [requestId, ...args] : args;

    if (sentryLoggingNamespaces.includes(namespace)) {
      Sentry.addBreadcrumb({
        type: 'debug',
        category: namespace,
        message,
        data: Object.assign({}, args)
      });
    }

    return debug(formattedMessage, ...argsWithRequestId);
  };
};
